/* eslint-disable react/prop-types */
import React from 'react';
import { formatURLforPPC } from 'SharedHelpers/formatURLforPPC';
import { Subscription } from 'Components/organisms/Subscription';

export const getPromobox = (props = {}) => {
  if (typeof props !== 'object' || Object.keys(props).length === 0) {
    return false;
  }
  const {
    ctaLabel = 'Sign up',
    ctaUrl = '#',
    excerpt = '',
    extraClassNames,
    image = null,
    imageSize = null,
    mainTitle = '',
    title = '',
    titleSize = 4,
    ppc,
  } = props;

  const clonedCtaUrl = (ctaUrl !== '#')
    ? (ctaUrl && true && formatURLforPPC({
      url: ctaUrl,
      ppc: ppc || null,
    })) : ctaUrl;

  return (
    <Subscription
      ctaLabel={ctaLabel}
      ctaUrl={clonedCtaUrl}
      excerpt={excerpt}
      extraClassNames={extraClassNames || {}}
      image={image}
      imageSize={imageSize}
      mainTitle={mainTitle}
      title={title}
      titleSize={titleSize}
    />
  );
};
